import { createContext, ReactNode, useContext } from "react";

export interface IAppBarAction {

    body: ReactNode;

    icon: ReactNode;

    executeAsync: () => Promise<void>;
}

export interface IAppBarState {
    backVisible?: boolean;
    largeLogo?: boolean;
    title?: string;
    actions?: IAppBarAction[];
    isMenuOpen?: boolean;
    onUserLogoClick?: () => void;
}

interface IAppBarContext {
    setState: (value: IAppBarState) => void;
}

export const AppBarContext = createContext({
    setState: null
} as IAppBarContext);

export function useAppBar() {
    return useContext(AppBarContext).setState;
}

export default useAppBar;